'use strict';

var _ = require('lodash');
var GridToolbarConfigurationUserDefinedRefDataMarketController = function GridToolbarConfigurationUserDefinedRefDataMarketController($scope, $rootScope, urdToolbarService, urdConstants, printService, toolbarGridService) {
  $scope.isDeleteButtonShown = false;
  $scope.isDuplicateButtonShown = false;
  $scope.selectedRows = [];
  var HEP_TYPE = urdConstants.HEP_TYPE.MARKET;
  $scope.onRowSelection = function (selectedRows) {
    $scope.isDuplicateButtonShown = selectedRows.length === 1;
    $scope.isDeleteButtonShown = selectedRows.length > 0;
    $scope.selectedRows = selectedRows;
  };
  $scope.addURDMarketRow = function () {
    urdToolbarService.addURDRow($scope.jqxGridSettings.source.loadedData, $scope.jqxGridSettings.columns);
    $scope.updateData($scope.jqxGridSettings.source.loadedData);
  };
  $scope.duplicateURDMarketRow = function () {
    urdToolbarService.duplicateURDRow($scope.jqxGridSettings.source.loadedData, $scope.jqxGridSettings.jqxGrid('getselectedrowindex'), $scope.jqxGridSettings.columns);
    $scope.updateData($scope.jqxGridSettings.source.loadedData);
  };
  function marketHepKeyCreator(urdRow) {
    var filter = [];
    filter.push(HEP_TYPE);
    filter.push(urdRow.marketEntity || null);
    if (urdRow.market) {
      filter = filter.concat(urdRow.market.split('-'));
    }
    filter.push(urdRow.pos || null);
    filter.push(urdRow.marketProduct || null);
    filter.push(urdRow.demandSeason || null);
    filter.push(urdRow.dowGroup || null);
    filter.push(urdRow.referenceMetric ? urdToolbarService.getMarketReferenceMetric(urdRow.referenceMetric) : null);
    return filter.filter(Boolean).join('.');
  }
  var rowsToRemoveFromServer = [];
  $scope.removeURDMarketRow = function () {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    var selectedIndexes = $scope.jqxGridSettings.jqxGrid('getselectedrowindexes');
    for (var i = 0; i < selectedIndexes.length; i++) {
      var row = loadedData[selectedIndexes[i]];
      if (!row.isRowEditable && !row.isNewlyAdded) {
        rowsToRemoveFromServer.push(row);
      }
    }
    toolbarGridService.removeRow($scope);
  };
  $scope.saveChanges = function () {
    if (!_.isEmpty(rowsToRemoveFromServer)) {
      urdToolbarService.removeURDRow(rowsToRemoveFromServer, HEP_TYPE, marketHepKeyCreator).then(function () {
        rowsToRemoveFromServer = [];
        $scope.$emit('grid:dataChanged');
      });
    }
    urdToolbarService.save(HEP_TYPE, $scope.jqxGridSettings.source.loadedData, marketHepKeyCreator).then(function () {
      $scope.$emit('grid:dataChanged');
    });
  };
  $scope.exportedDataTransformer = function (xmlString) {
    return xmlString.replace(/DISABLED/g, 'INACTIVE');
  };
  $scope["import"] = function () {
    $scope.isImportValidationError = false;
    $rootScope.$broadcast('grid:showImportModal', $scope.gridId);
  };
  $scope.printGrid = function () {
    $scope.asyncGridApply('exportdata', 'html').then(function (gridContent) {
      printService.print($scope.gridId, $scope.exportedDataTransformer(gridContent));
    });
  };
};
GridToolbarConfigurationUserDefinedRefDataMarketController.$inject = ['$scope', '$rootScope', 'ConfigurationUserDefinedRefDataGridToolbarFunctionsService', 'UrdConstants', 'PrintService', 'ToolbarGridService'];
module.exports = GridToolbarConfigurationUserDefinedRefDataMarketController;